declare let gtag: Function;

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-mode-selection',
  templateUrl: './mode-selection.component.html',
  styleUrls: ['./mode-selection.component.css']
})
export class ModeSelectionComponent {

  constructor(private router: Router, public auth: AuthService) {}

  selectDigitization(): void {
    this.router.navigate(['/digitize']);
  }

  selectDossierManagement(): void {
    if (this.auth.isAuthenticated) {
      this.router.navigate(['/dossiers']);
    } else {
      if (typeof gtag === 'function') {
        gtag('event', 'registration_initiated', { event_category: 'engagement', event_label: 'dossier_card' });
      }
      this.auth.register();
    }
  }

  registerWithGoogle(event: Event): void {
    event.stopPropagation();
    if (typeof gtag === 'function') {
      gtag('event', 'registration_initiated', { event_category: 'engagement', event_label: 'dossier_card_google' });
    }
    this.auth.registerWithGoogle();
  }
}
